import { render, staticRenderFns } from "./requestNumberAndUsersReports.vue?vue&type=template&id=d2f605f6&scoped=true"
import script from "./requestNumberAndUsersReports.vue?vue&type=script&lang=js"
export * from "./requestNumberAndUsersReports.vue?vue&type=script&lang=js"
import style0 from "./requestNumberAndUsersReports.vue?vue&type=style&index=0&id=d2f605f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f605f6",
  null
  
)

export default component.exports